function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface142553732"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,21.960784%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 21 2 C 19.355469 2 18 3.355469 18 5 L 18 7 L 8 7 C 7.640625 6.996094 7.304688 7.183594 7.121094 7.496094 C 6.941406 7.808594 6.941406 8.191406 7.121094 8.503906 C 7.304688 8.816406 7.640625 9.003906 8 9 L 9 9 L 9 45 C 9 46.652344 10.347656 48 12 48 L 38 48 C 39.652344 48 41 46.652344 41 45 L 41 9 L 42 9 C 42.359375 9.003906 42.695312 8.816406 42.878906 8.503906 C 43.058594 8.191406 43.058594 7.808594 42.878906 7.496094 C 42.695312 7.183594 42.359375 6.996094 42 7 L 32 7 L 32 5 C 32 3.355469 30.644531 2 29 2 Z M 21 4 L 29 4 C 29.554688 4 30 4.445312 30 5 L 30 7 L 20 7 L 20 5 C 20 4.445312 20.445312 4 21 4 Z M 19 14 C 19.550781 14 20 14.449219 20 15 L 20 40 C 20 40.554688 19.550781 41 19 41 C 18.449219 41 18 40.554688 18 40 L 18 15 C 18 14.449219 18.449219 14 19 14 Z M 25 14 C 25.550781 14 26 14.449219 26 15 L 26 40 C 26 40.554688 25.550781 41 25 41 C 24.449219 41 24 40.554688 24 40 L 24 15 C 24 14.449219 24.449219 14 25 14 Z M 31 14 C 31.554688 14 32 14.449219 32 15 L 32 40 C 32 40.554688 31.554688 41 31 41 C 30.445312 41 30 40.554688 30 40 L 30 15 C 30 14.449219 30.445312 14 31 14 Z M 31 14 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.61cae1fa9a2809fce87d722b0d793911.svg";
export { ForwardRef as ReactComponent };